import { Box, Text } from 'braid-design-system';
import React, { useEffect, useState } from 'react';

import { getQueryParams } from 'src/modules/utils';

export const InfoBanner = () => {
  const { v: branchName } = (typeof window !== 'undefined' &&
    typeof window.location !== 'undefined' &&
    getQueryParams(window.location.href)) || { v: undefined };

  const [showInfoBanner, setShowInfoBanner] = useState(false);

  useEffect(() => {
    if (branchName) setShowInfoBanner(true);
  }, [branchName]);

  return showInfoBanner ? (
    <Box
      id="info-banner"
      padding="small"
      background="brandAccent"
      textAlign="center"
    >
      <Text size="small" tone="neutral">
        Branch: {branchName?.replace('branch-', '')}
      </Text>
    </Box>
  ) : null;
};
